import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { errorMessage, successMessage } from "../../utilities/notification";
import {
  SUBSCRIPTION_LIST,
  DELETE_SUBSCRIPTION,
  EXPORT_SUBSCRIPTION,
  SMS_SUBSCRIPTION_LIST,
  DELETE_SMS_SUBSCRIPTION,
  EXPORT_SMS_SUBSCRIPTION,
} from "../actions/subscription.actions.types";

const call = Effects.call;

function* getSubscriptionList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "subscriptions/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteSubscription({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `subscriptions/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* exportSubscription({ payload: { callback } }) {
  const payload = {
    method: "get",
    url: "subscriptions/export",
    responseType: "blob",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    errorMessage("Something went wrong");
  } else {
    const url = window.URL.createObjectURL(new Blob([result]));
    const a = document.createElement("a");
    a.href = url;
    a.download = "subscriptions.csv";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    successMessage("Exported successful!");
    if (callback) callback({ success: true, data: result });
  }
}

function* getSmsSubscriptionList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "sms-subscriptions/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteSmsSubscription({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `sms-subscriptions/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* exportSmsSubscription({ payload: { callback } }) {
  const payload = {
    method: "get",
    url: "sms-subscriptions/export",
    responseType: "blob",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    errorMessage("Something went wrong");
  } else {
    const url = window.URL.createObjectURL(new Blob([result]));
    const a = document.createElement("a");
    a.href = url;
    a.download = "subscriptions.csv";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    successMessage("Exported successful!");
    if (callback) callback({ success: true, data: result });
  }
}

function* Subscription() {
  yield all([
    takeLatest(SUBSCRIPTION_LIST, getSubscriptionList),
    takeLatest(DELETE_SUBSCRIPTION, deleteSubscription),
    takeLatest(EXPORT_SUBSCRIPTION, exportSubscription),
    takeLatest(SMS_SUBSCRIPTION_LIST, getSmsSubscriptionList),
    takeLatest(EXPORT_SMS_SUBSCRIPTION, exportSmsSubscription),
    takeLatest(DELETE_SMS_SUBSCRIPTION, deleteSmsSubscription),
  ]);
}

export default Subscription;
